import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { ListItem } from '../../ListItem'
import { ServiceRequestsWidgetItemContent } from '../ServiceRequestsWidgetItemContent'

import * as styles from './ServiceRequestsWidgetItem.module.css'

import ServiceRequestIcon from '../../../icons/service-request.svg'

function ServiceRequestsWidgetItem({
  className = styles.ServiceRequestsWidgetItem,
  contentContainerProps: {
    className: contentContainerClassName = styles.contentContainer,
    ...contentContainerProps
  } = EMPTY_OBJECT,
  hoverClassName = styles.hover,
  ...restProps
}) {
  return (
    <ListItem
      {...restProps}
      Content={ServiceRequestsWidgetItemContent}
      ListIcon={ServiceRequestIcon}
      className={className}
      contentContainerProps={{
        ...contentContainerProps,
        className: contentContainerClassName,
      }}
      hoverClassName={hoverClassName}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
    />
  )
}

export default ServiceRequestsWidgetItem
